import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

export const useLogViewFoundPassword = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(() => {
    logAnalyticsEvent({
      name: 'VIEW_FOUND_PASSWORD',
      channel: ['firebase', 'amplitude', 'ablylog'],
      analytics: {
        SCREEN: 'FOUND_PASSWORD',
      },
    });
  }, [logAnalyticsEvent]);
};
